@if (showBanner()) {
  <div
    class="flex flex-row items-start justify-between gap-2 border-b-2 border-[#F97316] bg-[#F9731633] px-6 py-5 text-primary-text lg:px-8 print:hidden"
  >
    <div>
      {{ 'components.unpaidSubscriptionBanner.text' | translate }}
    </div>
    <button
      class="align-end btn btn-icon-only size-8 shrink-0"
      (click)="showBanner.set(false)"
      aria-label="{{
        'components.unpaidSubscriptionBanner.closeButtonText' | translate
      }}"
    >
      <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.192 0.34375L5.94897 4.58575L1.70697 0.34375L0.292969 1.75775L4.53497 5.99975L0.292969 10.2418L1.70697 11.6558L5.94897 7.41375L10.192 11.6558L11.606 10.2418L7.36397 5.99975L11.606 1.75775L10.192 0.34375Z"
          fill="currentColor"
        />
      </svg>
    </button>
  </div>
}
